export const img_url = "/";
export const id ="1"
export const COMPANYID = 1;
export const JOB_TITLE ='37'
